import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { CAMPAIGN_TYPES, wizardEntities } from 'containers/AwarenessCenter/constants'

import { selectDefaultLocaleId, selectSelectedTrainingVideo } from '../selectors'

import {
  createCustomTrainingError,
  createCustomTrainingSuccess,
  fetchTrainingVideosError,
  fetchTrainingVideosSuccess,
  uploadCustomVideoSuccess,
  uploadVideoLinkError,
} from './actions'
import {
  CREATE_CUSTOM_TRAINING_ASYNC,
  CUSTOM_MODULE_IMAGE_PREVIEW,
  CUSTOM_MODULE_NAME_URL,
  CUSTOM_MODULE_TYPES,
  FETCH_TRAINING_VIDEOS_ASYNC,
  SOURCE_VALUES,
  TRAINING_VIDEO_TYPES,
  UPLOAD_VIDEO_LINK_ASYNC,
} from './constants'

const fetchTrainingVideosEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_TRAINING_VIDEOS_ASYNC.INITIATE)
    .filter(({ payload }) => payload.vendor !== SOURCE_VALUES.CUSTOM_MODULE)
    .switchMap((action) => {
      const defaultLocaleId = selectDefaultLocaleId(store.getState())
      const selectedLocaleIds =
        store.getState().awarenessCenter[wizardEntities[CAMPAIGN_TYPES.SIMULATION]]?.self?.campaign
          ?.selectedLocaleIds || []
      const localeIds = selectedLocaleIds.includes(defaultLocaleId)
        ? selectedLocaleIds
        : [defaultLocaleId, ...selectedLocaleIds]

      return api.wizardCampaign
        .getTrainingVideos(
          store.getState().partnerOptions.selectedCompany?.value,
          action.payload.vendor,
          localeIds
        )
        .switchMap((response) => Observable.of(fetchTrainingVideosSuccess(response)))
        .catch((error) => Observable.of(epicsErrorHandler(fetchTrainingVideosError, error, [400])))
        .takeUntil(action$.ofType(FETCH_TRAINING_VIDEOS_ASYNC.CANCEL))
    })

const uploadVideoLinkEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPLOAD_VIDEO_LINK_ASYNC.INITIATE).mergeMap((action) =>
    api.wizardCampaign
      .uploadVideoLink(
        action.payload.url,
        action.payload.localeId,
        action.payload.trainingId || null
      )
      .mergeMap(({ response = {} }) => {
        const selectedTrainingVideo = selectSelectedTrainingVideo(store.getState())
        const isCustomToVendor = selectedTrainingVideo[0]?.vendor === SOURCE_VALUES.CUSTOM_MODULE
        const items = isCustomToVendor ? selectedTrainingVideo[0]?.items || [] : []
        const curLocaleIndex = items.findIndex(
          ({ localeId }) => localeId === action.payload.localeId
        )
        const localeItem = {
          localeId: action.payload.localeId,
          imagePreview: CUSTOM_MODULE_IMAGE_PREVIEW,
          content: action.payload.url,
          customType: CUSTOM_MODULE_TYPES.CUSTOM_URL,
        }

        if (curLocaleIndex >= 0) {
          items[curLocaleIndex] = localeItem
        } else {
          items.push(localeItem)
        }

        return Observable.of(
          uploadCustomVideoSuccess({
            id: response.id,
            name: CUSTOM_MODULE_NAME_URL,
            vendor: SOURCE_VALUES.CUSTOM_MODULE,
            type: TRAINING_VIDEO_TYPES.CUSTOM_CONTENT.value,
            items,
          })
        )
      })
      .catch((error) => Observable.of(epicsErrorHandler(uploadVideoLinkError, error, [400])))
  )

const createCustomTrainingEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(CREATE_CUSTOM_TRAINING_ASYNC.INITIATE).mergeMap(() =>
    api.wizardCampaign
      .createCustomTraining()
      .mergeMap(({ response = {} }) => Observable.of(createCustomTrainingSuccess(response.id)))
      .catch((error) => Observable.of(epicsErrorHandler(createCustomTrainingError, error, [400])))
  )

export default combineEpics(fetchTrainingVideosEpic, uploadVideoLinkEpic, createCustomTrainingEpic)
